import { render, staticRenderFns } from "./citationPushDetails.vue?vue&type=template&id=4820f0f0&scoped=true"
import script from "./citationPushDetails.vue?vue&type=script&lang=js"
export * from "./citationPushDetails.vue?vue&type=script&lang=js"
import style0 from "./citationPushDetails.vue?vue&type=style&index=0&id=4820f0f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4820f0f0",
  null
  
)

export default component.exports